/******************************************************************************************
 *	Array to CSV string
 *******************************************************************************************
 *
 * Convets an array of objects to CSV formatted string
 *
 */
(function() {
  

  angular
    .module('rcServices.arrayToCsv', [])
    .constant('CSV_ROW_SEPARATOR', '\n')
    .constant('CSV_COLUMN_SEPARATOR', ',')
    .service(
      'ArrayToCsv',
      /* @ngInject */
      function(_, CSV_ROW_SEPARATOR, CSV_COLUMN_SEPARATOR) {
        //Wraps string inside double quotes and escapes other double quotes
        var wrap = function(str) {
          if (_.isNil(str)) {
            str = '';
          } else if (!_.isString(str)) {
            str += ''; //Force convert to string
          }

          return '"' + _.replace(str, /"/g, '""') + '"';
        };

        this.convert = function(data) {
          var output = '';
          for (var i = 0, count = data.length; i < count; i++) {
            var obj = data[i];
            var row = [];
            for (var prop in obj) {
              // Exclude properties that begin with $
              if (prop.charAt(0) !== '$') {
                row.push(wrap(obj[prop]));
              }
            }
            output += row.join(CSV_COLUMN_SEPARATOR) + CSV_ROW_SEPARATOR;
          }
          return output;
        };
      }
    );
})();
